import styled from 'styled-components';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';
import {
  Dropdown as SemanticDropdown,
  Icon,
  Input,
} from 'semantic-ui-react';

export const Dropdown = styled(SemanticDropdown)`
  flex: 1;
  margin-right: 8px;

  &.ui.dropdown .menu {
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
  }
  &.ui.dropdown > .text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
  &.ui.multiple.dropdown > .label {
    overflow-wrap: break-word;
    text-overflow: ellipsis;
    max-width: 100%;
  }
`;

export const OperatorDropdown = styled(SemanticDropdown)`
  margin-right: 8px;

  &.ui.dropdown > .text {
    width: 70px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
  &.ui.dropdown {
    min-width: unset;
    width: 80px;
  }
`;

export const ConditionRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #192C47;
`;

export const HeaderIcon = styled(Icon)`
  &&& {
    margin-right: 5px;
  }
`;

export const DropdownHeader = styled(Dropdown.Header)`
  &&& {
    font-weight: bold;
    cursor: pointer;
    text-transform: none !important;
    font-size: 1rem !important;
  }
`;

export const SearchInputContainer = styled.div`
  padding: 8px;
`;

export const DropdownSearchInput = styled(Input)`
  &&&.ui.input > input {
    color: ${(props) => props.theme.color.searchInputTextActive};
    font-family: Roboto;
    border: 1px solid ${(props) => props.theme.color.searchInputBorder};
    border-radius: 4px !important;
    font-size: 14px;
    height: 38px;
    padding: 10px;
    width: 100%;
  }
  &&&.ui.input {
    width: 100%;
  }
  .icon {
    color: ${(props) => props.theme.color.primary};
    font-size: 15px;
    opacity: initial !important;
  }
`;

export const OperatorContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const Operator = styled.a`
  cursor: pointer;
  padding: 6px;
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
`;

export const SavedFilterContainer = styled.div`
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 15px;
  position: relative;
`;

export const SavedFilterLeftContainer = styled.div`
  display: flex;
  align-items: start;
`;

export const SavedFilterTopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
`;

export const ThreeDotDropdown = styled.div`
  .ui.dropdown .menu {
    min-width: unset;
  }
  .ui.dropdown .menu > .item {
    color: ${({ theme }) => theme.color.textError};
  }
`;

export const FilterConditions = styled(TextLayoutComponent)`
  font-size: 14px;
  margin-left: 26px;
`;

export const FilterName = styled(TextLayoutComponent.Bold)`
  font-size: 14px;
  margin-bottom: 0;
  color: #000;
`;
